import { graphql, useStaticQuery } from 'gatsby'

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query SiteMetaData {
        site {
          siteMetadata {
            author
            description
            siteUrl
            title
            twitterUsername
          }
        }
      }
    `,
  )

  return site.siteMetadata
}

export default useSiteMetadata
